import { buildChannel } from "./util";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: buildChannel(),
  enabled: buildChannel() == "prod",
});

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { SENTRY_DSN } from "./config";
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
